import {ChangeDetectionStrategy, Component} from "@angular/core";
import {HeaderComponent} from "../../components/header/header.component";
import {SignupFormComponent} from "../../components/signup-form/signup-form.component";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, SignupFormComponent],
})
export class SignupComponent {}
